import { makeStyles } from '@material-ui/core';
import { useField } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';
import FieldHelperText from '~components/field-helper-text';
import Switch from './index';

const useStyles = makeStyles(() => ({
  switchContainer: { height: ({ height }) => height },
}));

const FormikSwitch = React.forwardRef((props, ref) => {
  const { fieldConfig, FieldHelperTextProps, height, ...others } = props;
  const classes = useStyles({ height });
  const [field, meta] = useField(
    typeof fieldConfig === 'string' ? { name: fieldConfig, type: 'checkbox' } : fieldConfig
  );

  return (
    <>
      <Switch className={classes.switchContainer} {...field} {...others} ref={ref} />
      <FieldHelperText type="error" {...FieldHelperTextProps}>
        {FieldHelperTextProps?.children ?? meta.error}
      </FieldHelperText>
    </>
  );
});

FormikSwitch.propTypes = {
  fieldConfig: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  FieldHelperTextProps: PropTypes.object,
  height: PropTypes.number,
};
FormikSwitch.defaultProps = {
  FieldHelperTextProps: undefined,
  height: 40,
};

export default FormikSwitch;
